<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><i>History is not the past.</i></p>
<p class="alignment-block-content alignment-block-content-left"><i>It is the present.</i></p>
<p class="alignment-block-content alignment-block-content-left"><i>We carry our history with us.</i></p>
<p class="alignment-block-content alignment-block-content-left">— James Baldwin, I am not your negro</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><i>The past is a foreign country: they do things differently there.</i></p>
<p class="alignment-block-content alignment-block-content-left">— LP Hartley, The Go-Between</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><i>Pure memory remains as elusive as a bar of wet soap.</i></p>
<p class="alignment-block-content alignment-block-content-left">— John Le Carré, The Pigeon Tunnel</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><i>What’s past is prologue.</i></p>
<p class="alignment-block-content alignment-block-content-left">— William Shakespeare, The Tempest</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?5b100720